import { isAppleDevice, isMac } from '../utils';
export function isNonContiguousSelectionModifier(e) {
    // Ctrl + Arrow Up/Arrow Down has a system wide meaning on macOS, so use Alt instead.
    // On Windows and Ubuntu, Alt + Space has a system wide meaning.
    return isAppleDevice() ? e.altKey : e.ctrlKey;
}
export function isCtrlKeyPressed(e) {
    if (isMac()) {
        return e.metaKey;
    }
    return e.ctrlKey;
}

//# sourceMappingURL=utils.js.map